import storage from 'store'
import api from '@api'
import { ACCESS_TOKEN, USER_INFO, SID, TID } from '@store/mutation-types.js'

const user = {
  state: {
    token: '',
    info: {},
    tid: '',
    sid: '',
    name: '',
    avatar: '',
    enterprise: {},
    stadium: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_TID: (state, tid) => {
      state.tid = tid
    },
    SET_SID: (state, sid) => {
      state.sid = sid
    },
    SET_STADIUM: (state, stadium) => {
      state.stadium = stadium
    },
    SET_ENTERPRISE: (state, enterprise) => {
      state.enterprise = enterprise
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        api.user
          .login(userInfo)
          .then((response) => {
            const result = response.data
            storage.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            storage.set(USER_INFO, result.info, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        api.user
          .getInfo()
          .then((response) => {
            const result = response.result

            commit('SET_INFO', result)
            commit('SET_AVATAR', result.avatar || result.enterprise.logo)
            commit('SET_ENTERPRISE', result.enterprise)
            commit('SET_STADIUM', result.stadiums)
            let sid = storage.get(SID)
            let tid = storage.get(TID)
            const stadium = result.stadiums.find((row) => {
              return row.sid === sid
            })
            if (!sid || !stadium) {
              sid = result.stadiums[0].sid
              commit('SET_SID', sid)
              storage.set(SID, sid)
              tid = result.stadiums[0].tid * 1
              commit('SET_TID', tid)
              storage.set(TID, tid)
            } else {
              commit('SET_SID', sid)
              commit('SET_TID', tid)
            }

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_INFO', {})
        storage.remove(ACCESS_TOKEN)

        resolve()
      })
    },
  },
}

export default user
